const auth = {
  hasPermission: (permission, currentPermissions) => {
    const findPermission = currentPermissions.find(rolPermission => rolPermission === permission);
    return findPermission ? true : false;
  },
};

export default auth;
